// TimeNotSyncWithServerModal.js
import { connect } from 'react-redux';

import TimeNotSyncWithServerModal from '../component/TimeNotSyncWithServerModal.jsx';

import getExternalData from '../selector/getExternalData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import toggleModal from '../action/toggleModal.js';
import { LIVESTREAM_TIME_DRIFT_THRESHOLD_SECONDS } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    clientTimestamp: getExternalData(state, ['timestamp'], 'client'),
    serverTimestamp: getExternalData(state, ['timestamp'], 'server'),
    timeOffsetSecondsWithServer: getTimestampOffset(state, Accuracy.SECOND),
    timeDriftThresholdSeconds: getRemoteConfigData(
      state,
      LIVESTREAM_TIME_DRIFT_THRESHOLD_SECONDS
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: payload => dispatch(toggleModal(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeNotSyncWithServerModal);
